import axios from "axios";

export const axiosConnect = axios.create({
  baseURL: process.env.REACT_APP_BACKEND || "http://localhost:2004/v2"
});

// process.env.REACT_APP_BACKEND
// Railway: "devsensorbackend-production.up.railway.app"
// localHost: "http://localhost:5001" || process.env.REACT_APP_BACKEND
